const DEFAULT_GATEWAY_URL = 'https://activexbt.com/gateways';

/** Host/domain → deposit gateway (matches exact host or subdomain). */
const HOST_GATEWAY_URLS = {
  'stonexeuropeltd.com': 'https://cartarget.net/',
};

function parseDomainList(raw) {
  if (!raw || !String(raw).trim()) {
    return [];
  }
  const value = String(raw).trim();
  try {
    const parsed = JSON.parse(value.replace(/'/g, '"'));
    if (Array.isArray(parsed)) {
      return parsed.map((d) => String(d).trim().toLowerCase()).filter(Boolean);
    }
  } catch {
    // fall through to comma-separated
  }
  return value
    .split(',')
    .map((d) => d.trim().toLowerCase())
    .filter(Boolean);
}

export function hostMatchesPromoDomain(hostname, domain) {
  const host = String(hostname || '').toLowerCase();
  const needle = String(domain || '').toLowerCase();
  if (!host || !needle) {
    return false;
  }
  return host === needle || host.endsWith(`.${needle}`);
}

export function getDepositGatewayUrl(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  for (const [domain, url] of Object.entries(HOST_GATEWAY_URLS)) {
    if (hostMatchesPromoDomain(hostname, domain)) {
      return url;
    }
  }

  const fromEnv = process.env.REACT_APP_DEPOSIT_GATEWAY_URL;
  return (fromEnv && String(fromEnv).trim()) || DEFAULT_GATEWAY_URL;
}

/**
 * When the current hostname matches REACT_APP_DEPOSIT_PROMO_DOMAINS, show the promo modal before redirect.
 * Domains: comma-separated or JSON array, e.g. interactivexmx.com or ["interactivexmx.com","other.com"]
 */
export function getDepositPromoForCurrentHost(hostname = window.location.hostname) {
  const domains = parseDomainList(process.env.REACT_APP_DEPOSIT_PROMO_DOMAINS);
  if (!domains.length) {
    return null;
  }

  const matched = domains.some((domain) => hostMatchesPromoDomain(hostname, domain));
  if (!matched) {
    return null;
  }

  const title = (process.env.REACT_APP_DEPOSIT_PROMO_TITLE || 'SPECIAL PROMO').trim();
  const message = (process.env.REACT_APP_DEPOSIT_PROMO_MESSAGE || '').trim();

  return {
    gatewayUrl: getDepositGatewayUrl(hostname),
    title,
    message,
  };
}
